export default __webpack_public_path__ + "static/media/wenn-eine-tannigi-hose-haet.1aca68d5.png";